/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which method is most accurate?`)
};

const es_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué método es más preciso?`)
};

const de_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Methode ist am genauesten?`)
};

const nl_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke methode is het nauwkeurigst?`)
};

const fr_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle méthode est la plus précise ?`)
};

const it_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale metodo è più accurato?`)
};

const pt_br2_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual método é mais preciso?`)
};

const pt_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o método mais preciso?`)
};

const ja_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も正確な方法はどれですか？`)
};

const zh_tm_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哪种方法最准确？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_q1", locale)
	if (locale === "en") return en_tm_faq_q1(inputs)
	if (locale === "es") return es_tm_faq_q1(inputs)
	if (locale === "de") return de_tm_faq_q1(inputs)
	if (locale === "nl") return nl_tm_faq_q1(inputs)
	if (locale === "fr") return fr_tm_faq_q1(inputs)
	if (locale === "it") return it_tm_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_q1(inputs)
	if (locale === "pt") return pt_tm_faq_q1(inputs)
	if (locale === "ja") return ja_tm_faq_q1(inputs)
	return zh_tm_faq_q1(inputs)
};